import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import get from 'lodash/get';
import { Fade } from '@material-ui/core';

import Grid from '../../../components/molecules/Grid';
import Typography from '../../../components/atoms/Typography';
import Picture from '../../../components/atoms/Picture';
import Title from '../../../components/atoms/Title';
import Box from '../../../components/molecules/Box';
import ButtonMUI from '../../../components/atoms/Button';
import { analyticsData } from '../../../../constants/Analytics/analytics-data';
import { pushAnaylyticsData } from '../../../../utils/analytics';
import RichText from '../../../components/atoms/RichText';

import aspectRatios from '../../../utils/AspectRatios';
import { createDynamicLabels } from '../../../../../src/utils/analytics';

const TabContent = props => {
  const {
    stopHeading,
    stopTitle,
    location,
    timing,
    description,
    link,
    readMoreText,
    classes,
    pageName,
    componentName,
  } = props || {};

  let { frontImage, rearImage } = props || {};

  const readMore = get(link, 'value.text', '') || readMoreText;

  if (!get(frontImage, 'value.src', '')) {
    frontImage = {
      value: {
        src: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAACCAQAAAA3fa6RAAAADklEQVR42mNkAANGCAUAACMAA2w/AMgAAAAASUVORK5CYII=',
        '3x2': {
          large: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAACCAQAAAA3fa6RAAAADklEQVR42mNkAANGCAUAACMAA2w/AMgAAAAASUVORK5CYII=',
        },
      },
    }
  }
  if (!get(rearImage, 'value.src', '')) {
    rearImage = {
      value: {
        src: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAFCAQAAADIpIVQAAAADklEQVR42mNkgAJGIhgAALQABsHyMOcAAAAASUVORK5CYII=',
        '4x5': {
          large: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAFCAQAAADIpIVQAAAADklEQVR42mNkgAJGIhgAALQABsHyMOcAAAAASUVORK5CYII=',
        },
      },
    }
  }
  const addAnalyticsInfo = () => {
    const obj = {
      ...analyticsData.pageBodyInteraction.readMoreBtnClick,
      ...{ label: createDynamicLabels([pageName, componentName, stopHeading && stopHeading.value]) },
    };
    pushAnaylyticsData(obj);
  };
  return (
    <Fade in={true} timeout={1000}>
      <Grid container className={classes.tabWrapper}>
        <Grid item lg={4} className={classes.tabContent}>
          {stopTitle && <Title text={{ value: stopTitle }} className={classes.title} />}
          {
            stopHeading &&
            <Typography
              component="p"
              variant="h5"
              display="block"
              className={classes.mainTitle}
            >
              <Text field={stopHeading} />
            </Typography>
          }
          {location && location.value && (
            <Typography
              variant="body3"
              component="p"
              className={classes.regionField}
            >
              <Text field={location} />
            </Typography>
          )}
          {
            timing &&
            <Typography component="p" variant="body3Bold" className={classes.timing}>
              <Text field={timing} />
            </Typography>
          }
          {description && description.value && (
            <Typography
              component="p"
              variant="body1"
              className={classes.description}
            >
              <RichText
                innerHTML={description}
              />
            </Typography>
          )}
          {readMore && (
            <ButtonMUI
              component="span"
              buttonType="secondary"
              hasBorder={false}
              isStartIcon={true}
              size="small"
              field={link}
              onClick={addAnalyticsInfo}
            >
              <Typography component="span" variant="body2Bold">
                <Text field={{ value: readMore }} />
              </Typography>
            </ButtonMUI>
          )}
        </Grid>
        <Grid item lg={8} className={classes.imageWrapper}>
          <Box className={classes.imageSection}>
            <Box className={classes.frontImage}>
              <Picture
                media={{
                  image: frontImage,
                  aspectRatio: aspectRatios['3x2'],
                  disableLazyLoad: true,
                }}
                alternateAltText={stopHeading && stopHeading.value}
              />
            </Box>
            <Box className={`${classes.rearImage}`}>
              <Picture
                media={{
                  image: rearImage,
                  aspectRatio: aspectRatios['4x5'],
                  disableLazyLoad: true,
                }}
                alternateAltText={stopHeading && stopHeading.value}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Fade>
  );
};

export default TabContent;
